import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ResponsiveDialog from '@sophocles/components/ResponsiveDialog';

function DeleteInventoryDialog({ isDeleting = true, inventoryItem, open, onSubmit, onClose }) {
  const { t } = useTranslation();

  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      title={`${isDeleting ? t('actions.delete') : t('actions.recover')} ${t('general.inventory')}`}
      submitText={isDeleting ? t('actions.delete') : t('actions.recover')}
      onSubmit={onSubmit}
    >
      {isDeleting ? (
        <>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {t('inventory.deleteInventoryWarning')}
          </Typography>
          <Typography variant="body2">
            {t('inventory.confirmRemoveDevice', {
              iccid: inventoryItem?.radio?.iccid || inventoryItem?.radio?.mac_address || inventoryItem?.iccid,
            })}
          </Typography>
        </>
      ) : (
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t('inventory.recoverInventoryDescription')}
        </Typography>
      )}
    </ResponsiveDialog>
  );
}

export default DeleteInventoryDialog;
